import React, { useEffect, useState } from 'react';
import { navigate, RouteComponentProps } from '@reach/router';
import Page from 'components/shared/Page';
import CheckMark from 'images/Icon_Complete.png';
import { MOIntegration } from './MOIntegration';
import { MOListedOptions } from './MOListedOptions';
import { getNoParams } from "helpers/endpointCalls";
import { endpoints } from 'endpoints.config';
import { Spinner } from 'components/spinner/Spinner';
import ConfirmationBox from 'components/confirmationBox/ConfirmationBox';
import { AppPath } from 'appConstants';
import { QuoteExpiredModal } from './QuoteExpiredModal';

const MembershipOptions: React.FC<RouteComponentProps> = ({ location }) => {
	const [membershipQLoading, setMembershipQLoading] = useState<boolean>(true);
	const [membershipQErr, setMembershipQErr] = useState<boolean>(false);
	const [membershipQuestions, setMembershipQuestions] = useState<any>(null);
	const [membershipResultList, setMembershipResultList] = useState<boolean>(false);
	const [showInvoiceSuccessMsg, setShowInvoiceSuccessMsg] = useState<boolean>(false);
	const [openQuoteExpiredModal, setOpenQuoteExpiredModal] = useState<boolean>(false);
	const [currentStep, setCurrentStep] = useState<number | string>(1);

	const SUCCESS_MESSAGE = {
		title: 'Success!',
		message: 'You will receive an invoice email shortly.',
		buttonText: 'Sign in',
	};
	
	useEffect(() => {
		if(
			location && 
			location.state &&
			(location as any).state.quoteExpired
		){
			setOpenQuoteExpiredModal(true);
		}
	}, []);	

	useEffect(() => {
		loadData();
	}, []);

	const loadData = async () => {
		const result = await getNoParams(endpoints.public.subscription.getSubscriptionQuestionsInfo);

		if (result.response && !result.errors) {
			let multiSubArrIndex = findArrIndex(result.response.subjects, "name", "&");
			result.response.subjects.push(result.response.subjects.splice(multiSubArrIndex, 1)[0]);

			const euCountriesList = result.response.euCountries.map((country_item: any) => {
				return { label: country_item.name, value: country_item.id };
			});

			const otherCountriesList = result.response.otherCountries.map((country_item: any) => {
				return { label: country_item.name, value: country_item.id };
			});  			
			
			let membershipQuestions = result.response;
			membershipQuestions.selectedLocation = null;
			membershipQuestions.selectedLocationLabel = "";
			membershipQuestions.selectedPackage = null;
			membershipQuestions.selectedSubject = null;
			membershipQuestions.selectedSubjectName = null;
			membershipQuestions.ageGroup = null;
			membershipQuestions.pupilsOnRoll = 0;
			membershipQuestions.promoCodes = [];
			membershipQuestions.euCountries = euCountriesList;
			membershipQuestions.otherCountries = otherCountriesList;

			setMembershipQuestions(membershipQuestions);
			setMembershipQLoading(false);
		} else {
			setMembershipQErr(true);
			setMembershipQLoading(false);
		}
	};

	const findArrIndex = (array: any, attr: string, value: string) => {
		for(var i = 0; i < array.length; i += 1) {
			if(array[i][attr].indexOf(value) > -1) {
				return i;
			}
		}
		return -1;
	}	

    return (
        <Page isPublic={true} className={'MembershipOptionsPage'}>
					<div className="MembershipOptionsHeaderWrapper">
						<div className="MembershipOptionsAdditionalHeader WidthContent HeightContent">
							<div className="LeftCol">
								<h2>With every Get Set 4 Education subscription:</h2>

								<ul>
									<li>
										<img src={CheckMark} alt="Unlimited school users" /> Unlimited school users
									</li>
									<li>
										<img src={CheckMark} alt="Access to lesson plans and units of work " /> Access to lesson plans and units of work
									</li>
									<li>
										<img src={CheckMark} alt="Access to assessment and tracking software" /> Access to assessment and tracking software
									</li>
									<li>
										<img src={CheckMark} alt="Space to record and store pupil evidence" /> Space to record and store pupil evidence
									</li>
									<li>
										<img src={CheckMark} alt="Clubs and competitions/performances dashboard" /> Clubs and competitions/performances dashboard
									</li>
									<li>
										<img src={CheckMark} alt="Access to all resources in awesome stuff including CPD" /> Access to all resources in awesome stuff including CPD
									</li>     
									<li>
										<img src={CheckMark} alt="Personalised support" /> Personalised support
									</li>      
									<li>
										<img src={CheckMark} alt="Get Set 4 Life wellbeing programme" /> Get Set 4 Life wellbeing programme
									</li>    
									<li>
										<img src={CheckMark} alt="Discount code to use for equipment suppliers" /> Discount code to use for equipment suppliers
									</li>                                                      
								</ul>
							</div>
							<div className="RightCol">
								<div className="NotesPanel">
									<ul>
										<li>Save 10% when aligning your Get Set 4 PE and Get Set 4 Music subscriptions.</li>
										<li>MAT, cluster or federated schools...contact us for a personalised quote.</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					<div className="PageContent WidthContent HeightContent MOFormPage">
						{membershipQLoading && <Spinner />}
						{!membershipQLoading && membershipQErr && 
							<h2 className="GeneralErrTxt">An error occurred, please try again.</h2>						
						}

						{!membershipQLoading && !membershipQErr &&
							<>
								{membershipQLoading && <Spinner />}

								{membershipQuestions && !membershipResultList && !showInvoiceSuccessMsg &&
									<MOIntegration 
										membershipQuestions={membershipQuestions}									
										setMembershipQuestions={setMembershipQuestions}
										setMembershipResultList={setMembershipResultList}
										setCurrentStep={setCurrentStep}
										currentStep={currentStep}
										setMembershipQErr={setMembershipQErr}
									/>
								}

								{membershipResultList && !showInvoiceSuccessMsg &&
									<MOListedOptions 
										setMembershipQErr={setMembershipQErr}
										membershipQuestions={membershipQuestions}
										setMembershipResultList={setMembershipResultList}
										setCurrentStep={setCurrentStep}
									/>
								}

								{showInvoiceSuccessMsg &&
									<ConfirmationBox
										{...SUCCESS_MESSAGE}
										buttonOnClick={() => navigate(AppPath.SIGN_IN)}
									/>
								}
							</>
						}
					</div>

					{openQuoteExpiredModal &&
						<QuoteExpiredModal 
							panelOpen={openQuoteExpiredModal}
							togglePanelOpen={setOpenQuoteExpiredModal}
						/>                
					} 					
        </Page>
    );
};

export default MembershipOptions;